define('areas/home/model/dto',["require", "exports"], function (require, exports) {
    "use strict";
    var NavigationNode = (function () {
        function NavigationNode() {
            this.defaultData = new DefaultData();
            this.toggleDescription = false;
            this.uri = new Uri();
            this.groups = [];
            this.children = [];
            this.useImage = false;
            this.isHidden = false;
            ko.track(this, ["type", "name", "template", "datakey", "index", "icon", "color", "useImage", "imagePath", "groupId", "shopId", "isHidden", "addWidgetBack", "thumbnail", "toggleDescription", "imagePathSearchbar", "permissionId"]);
        }
        return NavigationNode;
    }());
    exports.NavigationNode = NavigationNode;
    var NavigationGroup = (function () {
        function NavigationGroup() {
        }
        return NavigationGroup;
    }());
    exports.NavigationGroup = NavigationGroup;
    var Uri = (function () {
        function Uri() {
        }
        Object.defineProperty(Uri.prototype, "absolute", {
            get: function () {
                if (this.path == "" && this.fragment == "")
                    return "";
                return (this.path == "")
                    ? this.fragment
                    : this.path + "/" + this.fragment;
            },
            enumerable: true,
            configurable: true
        });
        return Uri;
    }());
    exports.Uri = Uri;
    var DefaultData = (function () {
        function DefaultData() {
        }
        return DefaultData;
    }());
    exports.DefaultData = DefaultData;
});

